module.exports = __webpack_public_path__ + "img/indisch_monument_wolkjes_600x600px.7cc0c867.png";